import { useEffect } from 'react';

import { useCsvDownloadSetters } from '@/features/_shared/chart/context/CsvTableContext';

type UseCsvDownloadOptions = {
  fileName?: string;
  groupName?: string;
  dateColumnKey?: string | null;
};

const useCsvDownload = (
  from: string | undefined,
  downloadFileId: string | undefined,
  options?: UseCsvDownloadOptions
) => {
  const { fileName, groupName, dateColumnKey } = options ?? {};
  const { setDownloadFileId, setSelectedRange, setFileName, setGroupName, setDateColumnKey } =
    useCsvDownloadSetters();

  useEffect(() => {
    setDownloadFileId(downloadFileId);
    setSelectedRange(downloadFileId && from && from.length > 0 ? from : undefined);
    setFileName(fileName);
    setGroupName(groupName);
    setDateColumnKey(dateColumnKey);
  }, [
    from,
    downloadFileId,
    fileName,
    groupName,
    dateColumnKey,
    setDownloadFileId,
    setSelectedRange,
    setFileName,
    setGroupName,
    setDateColumnKey
  ]);

  return {};
};

export default useCsvDownload;
